interface DataDictionaryObject {
  key: string;
  description: string;
}

export const DATA: DataDictionaryObject[] = [
  {
    key: "cic",
    description:
      "Industry NNID if SPSR is not present. If SPSR is present, then the CIC represents the nnSR NNID",
  },
  { key: "cr", description: "Code Range Owner Industry NNID" },
  { key: "iso2", description: "Country" },
  {
    key: "name",
    description:
      'Name of the Carrier or Service Provider, associated with "cic"',
  },
  {
    key: "pi",
    description:
      "Port Indicator, indicates TRUE if the CR is not equal to the CIC (which means ported, entire number or hosted)",
  },
  {
    key: "type",
    description:
      "Industry Line Type, Mobile (Cellular Carrier) / Fixed (Landline)",
  },
  { key: "spsr", description: "If present, it is always the Industry NNID" },
  {
    key: "campaign_id",
    description: "A2P Campaign ID, if the number is registered as A2P",
  },
];
